import { render, staticRenderFns } from "./addcourse.vue?vue&type=template&id=8713f620&scoped=true&"
import script from "./addcourse.vue?vue&type=script&lang=js&"
export * from "./addcourse.vue?vue&type=script&lang=js&"
import style0 from "./addcourse.vue?vue&type=style&index=0&id=8713f620&lang=scss&scoped=true&"
import style1 from "./addcourse.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8713f620",
  null
  
)

export default component.exports